'use client';

import { useEffect } from 'react';

import { GTM_MANUAL_PUSH_ATTR } from '@/shared/constants/gtm';
import { pushGTMClickFromElement } from '@/shared/utils/gtm';

/**
 * `data-event` 가 붙은 엘리먼트의 클릭을 전역에서 수집해 dataLayer 로 push.
 *
 * 컴포넌트마다 onClick 을 손대지 않도록 document 위임으로 처리하며,
 * 하위 핸들러의 stopPropagation 에 가려지지 않게 capture 단계에서 듣는다.
 */
export function GTMClickTracker() {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (!(e.target instanceof Element)) return;

      const element = e.target.closest<HTMLElement>('[data-event]');
      if (!element || element.hasAttribute(GTM_MANUAL_PUSH_ATTR)) return;

      pushGTMClickFromElement(element);
    };

    document.addEventListener('click', handleClick, true);
    return () => document.removeEventListener('click', handleClick, true);
  }, []);

  return null;
}
